import disciplines from '../content/disciplines/disciplines.json';

/** @returns {typeof disciplines} All six core disciplines, in canonical order. */
export function getAllDisciplines() {
  return disciplines;
}

export function getDisciplineBySlug(slug) {
  return disciplines.find((d) => d.slug === slug);
}
